var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("basic-container", [_c("Search"), _c("Table")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }